export var BytesUnitId;
(function (BytesUnitId) {
    BytesUnitId["Bytes"] = "bytes";
    BytesUnitId["Kilobytes"] = "kilobytes";
    BytesUnitId["Megabytes"] = "megabytes";
    BytesUnitId["Gigabytes"] = "gigabytes";
    BytesUnitId["Terabytes"] = "terabytes";
    BytesUnitId["Petabytes"] = "petabytes";
    BytesUnitId["Bibytes"] = "bibytes";
    BytesUnitId["Kibibytes"] = "kibibytes";
    BytesUnitId["Mebibytes"] = "mebibytes";
    BytesUnitId["Gibibytes"] = "gibibytes";
    BytesUnitId["Tebibytes"] = "tebibytes";
    BytesUnitId["Pebibytes"] = "pebibytes";
    // deprecated
    BytesUnitId["b"] = "b";
    BytesUnitId["B"] = "B";
    BytesUnitId["KB"] = "KB";
    BytesUnitId["MB"] = "MB";
    BytesUnitId["GB"] = "GB";
})(BytesUnitId || (BytesUnitId = {}));
export var bytes = [
    {
        id: BytesUnitId.Bytes,
        alias: ["B", "bytes(B)"],
        divisor: 1,
        display: "B",
    },
    {
        id: BytesUnitId.Kilobytes,
        alias: ["KB", "kilobytes(KB)"],
        divisor: 1000,
        display: "KB",
    },
    {
        id: BytesUnitId.Megabytes,
        alias: ["MB", "megabytes(MB)"],
        divisor: Math.pow(1000, 2),
        display: "MB",
    },
    {
        id: BytesUnitId.Gigabytes,
        alias: ["GB", "gigabytes(GB)"],
        divisor: Math.pow(1000, 3),
        display: "GB",
    },
    {
        id: BytesUnitId.Terabytes,
        alias: ["TB", "terabytes(TB)"],
        divisor: Math.pow(1000, 4),
        display: "TB",
    },
    {
        id: BytesUnitId.Petabytes,
        alias: ["PB", "petabytes(PB)"],
        divisor: Math.pow(1000, 5),
        display: "PB",
    },
];
export var bibytes = [
    {
        id: BytesUnitId.Bibytes,
        alias: ["B", "bibytes(B)"],
        divisor: 1,
        display: "B",
    },
    {
        id: BytesUnitId.Kibibytes,
        alias: ["KiB", "kibibytes(KiB)"],
        divisor: 1024,
        display: "KiB",
    },
    {
        id: BytesUnitId.Mebibytes,
        alias: ["MiB", "mebibytes(MiB)"],
        divisor: Math.pow(1024, 2),
        display: "MiB",
    },
    {
        id: BytesUnitId.Gibibytes,
        alias: ["GiB", "gibibytes(GiB)"],
        divisor: Math.pow(1024, 3),
        display: "GiB",
    },
    {
        id: BytesUnitId.Tebibytes,
        alias: ["TiB", "tebibytes(TiB)"],
        divisor: Math.pow(1024, 4),
        display: "TiB",
    },
    {
        id: BytesUnitId.Pebibytes,
        alias: ["PiB", "pebibytes(PiB)"],
        divisor: Math.pow(1024, 5),
        display: "PiB",
    },
];
export var deprecatedBytes = [
    {
        id: BytesUnitId.b,
        divisor: 1,
        display: "b",
    },
    {
        id: BytesUnitId.B,
        divisor: 8,
        display: "B",
    },
    {
        id: BytesUnitId.KB,
        divisor: 8 * 1024,
        display: "KB",
    },
    {
        id: BytesUnitId.MB,
        divisor: 8 * 1024 * 1024,
        display: "MB",
    },
    {
        id: BytesUnitId.GB,
        divisor: 8 * 1024 * 1024 * 1024,
        display: "GB",
    },
];
//# sourceMappingURL=bytes.js.map